import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitUsageType } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import {
  IconCoverflexApp,
  IconCreditCard,
  IconGrid2,
  IconReimbursement,
} from '@coverflex-tech/hypernova';
import classnames from 'classnames';
import { css } from './BenefitsFilter.css';

const options: { icon: ReactNode; value: BenefitUsageType }[] = [
  {
    icon: <IconCoverflexApp />,
    value: 'app',
  },
  {
    icon: <IconCreditCard />,
    value: 'card',
  },
  {
    icon: <IconReimbursement />,
    value: 'reimbursement',
  },
];

interface IProps {
  selected: 'all' | BenefitUsageType;
  onChange: (option: 'all' | BenefitUsageType) => void;
  allowedFilters: BenefitUsageType[];
}

export const BenefitsFilter = ({
  selected,
  allowedFilters,
  onChange,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={css.host}>
      <button
        type="button"
        className={classnames(css.option, {
          [css.selected!]: selected === 'all',
        })}
        onClick={() => onChange('all')}
      >
        <IconGrid2 />
        <span>{t('dashboard.benefits.filters.all')}</span>
      </button>
      {options
        .filter((option) => allowedFilters.includes(option.value))
        .map(({ icon, value }) => (
          <button
            type="button"
            className={classnames(css.option, {
              [css.selected!]: selected === value,
            })}
            key={value}
            onClick={() => onChange(value)}
          >
            {icon}
            <span>{t(`dashboard.benefits.filters.${value}`)}</span>
          </button>
        ))}
    </div>
  );
};
